import { render, staticRenderFns } from "./EditBusiness.vue?vue&type=template&id=03388984&"
import script from "./EditBusiness.vue?vue&type=script&lang=ts&"
export * from "./EditBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./EditBusiness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports